// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__27Rs8","row":"Node_row__2iQze","label":"Node_label__yZXeY","footer":"Node_footer__2OBhI"};